import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productType'
})
export class ProductTypePipe implements PipeTransform {

    transform(value: string, args?: any): any {

        if (value) {
            let splitString = value.split("$");
            return splitString.length > 0 ? splitString[0] : splitString;
        }
        return value;

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/productType.pipe.ts